import { Component, OnInit } from '@angular/core';
import { ModalExtended} from 'ngx-dynamic-modal';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { AttemptProviderChangeService} from '../../services/attempt-provider-change.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-attempt-provider-change-modal',
  templateUrl: './attempt-provider-change-modal.component.html',
  styleUrls: ['./attempt-provider-change-modal.component.scss']
})
export class AttemptProviderChangeModalComponent extends ModalExtended implements OnInit {


    data:any;

    /**
     * portalpk,servicepk en entrada
     */
    params:any;

    /**
     * elemento en entrada
     */
    element:any={};

    formSearch: FormGroup;
    loading: boolean = false;

  constructor(private fb: FormBuilder,
              private  attemptService:AttemptProviderChangeService,
              private alerta: AlertaService) {
      super();

      this.formSearch = new FormGroup(
          {
              'service_provider_pk':new FormControl('',Validators.required),
              'context':new FormControl('',[Validators.required,Validators.pattern('^(_)[a-z0-9]*')]),
              'attempt':new FormControl('',Validators.min(1)),
              'text':new FormControl('',Validators.required),
              'type':new FormControl('',Validators.required),
              'active':new FormControl('0'),
              'delay':new FormControl(''),
              'line_type':new FormControl('')
          }
      );
  }

  ngOnInit() {
      this.params=this.data.params;
      if(this.data.element){
          this.element=this.data.element;
          this.formSearch.controls['service_provider_pk'].setValue(this.element.service_provider_pk);
          this.formSearch.controls['context'].setValue(this.element.context);
          this.formSearch.controls['attempt'].setValue(this.element.attempt);
          this.formSearch.controls['text'].setValue(this.element.text);
          this.formSearch.controls['type'].setValue(this.element.type);
          this.formSearch.controls['active'].setValue(this.element.active);
          this.formSearch.controls['delay'].setValue(this.element.delay);
          this.formSearch.controls['line_type'].setValue(this.element.line_type);
          }
  }

  saveData(form){
      if(form.valid){
          this.loading = true;
          let element=form.value;
          element['portal_pk']=this.params.portal_pk;
          element['service_pk']=this.params.service_pk;
          if(this.params.hasOwnProperty('camp_pk') && this.params.camp_pk > 0){
              element['service_campaign_pk']=this.params.camp_pk;
          }
          this.attemptService.postAttemptsProvChange(element)
              .subscribe(result=>{
                      this.onExit({edit:false,element:result.data});
                      this.loading = false;
                  }, error => {
                      //console.log(error);
                      this.alerta.addAlert('error','Something went wrong')
                  }, () => {
                      this.alerta.addAlert('success','Failover Config Created Succesfully!!')
                  })


      }
  }

  updateData(form){
       if(form.valid) {
           this.loading = true;
           let element = form.value;
           element['pk']=this.element.pk;
               this.attemptService.putAttemptsProvChange(element)
                   .subscribe(result => {
                       this.onExit({edit:true,element:result.data});
                       this.loading = false;
                   }, error => {
                       //console.log(error);
                       this.alerta.addAlert('error','Something went wrong')
                   }, () => {
                       this.alerta.addAlert('success','Failover Config Updated Succesfully!!')
                   })
       }
  }

  onExit(data) {
        this.applyCallback(data);
        this.close();
  }



}






// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/modals/attempt-provider-change-modal/attempt-provider-change-modal.component.ts